import { Component, OnInit } from '@angular/core';
import { ActivationEnd, Router, RouterOutlet } from '@angular/router';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';
import { provideIcons } from '@ng-icons/core';
import { tablerCopy } from '@ng-icons/tabler-icons';
import { LocaleService } from '@selfcare/cms';
import { combineLatest, distinctUntilChanged, map, tap } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { CmsPageUrl } from '@core/models';
import { Store } from '@ngrx/store';
import { CmsActions } from '@state/cms';
import { Title } from '@angular/platform-browser';
import { environment } from '@src/environments/environment';

dayjs.extend(utc);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  providers: [provideIcons({ tablerCopy })],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private readonly localeService: LocaleService,
    private readonly store: Store,
    private readonly router: Router,
    private readonly title: Title
  ) {}

  public ngOnInit() {
    if (!environment.production) {
      this.title.setTitle(`${this.title.getTitle()} | ${environment.pageSuffix}`);
    }

    combineLatest([
      this.router.events.pipe(
        filter((event) => event instanceof ActivationEnd),
        map((event: ActivationEnd) => event.snapshot?.data?.['cmsPageUrl']),
        filter((cmsPageUrl: CmsPageUrl) => !!cmsPageUrl),
        debounceTime(5),
        distinctUntilChanged()
      ),
      this.localeService.locale$,
    ])
      .pipe(
        debounceTime(10),
        tap(([cmsPageUrl, _]) => this.store.dispatch(CmsActions.getPageWidgets(cmsPageUrl)))
      )
      .subscribe();

    this.localeService.trackLocale().subscribe();
  }
}
